import type { BoardHint, Square } from '@halvard/board3d';
import { legalActions, type Action, type GameState, type Piece } from '@halvard/rules';

/** What a click next to the Mason does. */
export type MasonMode = 'move' | 'raise' | 'lower';

/** Actions of the selected piece that the current Mason mode allows. */
export function availableActions(
  state: GameState,
  piece: Piece | undefined,
  masonMode: MasonMode,
): Action[] {
  if (!piece) return [];
  const actions = legalActions(state, piece.id);
  if (piece.type !== 'M') return actions;
  return actions.filter((a) => {
    if (masonMode === 'move') return a.kind === 'move' || a.kind === 'capture';
    return a.kind === 'build' && a.delta === (masonMode === 'raise' ? 1 : -1);
  });
}

export function toHints(actions: readonly Action[]): BoardHint[] {
  return actions.map((a) => ({
    r: a.r,
    c: a.c,
    kind: a.kind === 'build' ? (a.delta > 0 ? 'raise' : 'lower') : a.kind,
  }));
}

export function actionAt(actions: readonly Action[], square: Square): Action | undefined {
  return actions.find((a) => a.r === square.r && a.c === square.c);
}
